  document.addEventListener('DOMContentLoaded', () => {
    // --- STICKY HEADER SCROLL LOGIC ---
    const headerWrapper = document.getElementById('SiteHeaderWrapper');

    window.addEventListener('scroll', () => {
      if (window.scrollY > 45) {
        headerWrapper.classList.add('scrolled');
      } else {
        headerWrapper.classList.remove('scrolled');
      }
    });

    // --- ROBUST DRAWER LOGIC (search + mobile menu only; cart uses native Dawn drawer) ---
    const triggers = document.querySelectorAll('.drawer-trigger');
    const closeBtns = document.querySelectorAll('.close-drawer');
    const overlay = document.querySelector('.drawer-overlay');
    const desktopDrawers = document.querySelectorAll('.side-drawer');
    const mobileMenu = document.getElementById('mobile-fullscreen-menu');

    function closeAllDrawers() {
      desktopDrawers.forEach((drawer) => drawer.classList.remove('active'));
      if (mobileMenu) mobileMenu.classList.remove('active');
      if (overlay) overlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = trigger.getAttribute('data-target');
        const targetDrawer = document.getElementById(targetId);

        if (targetDrawer) {
          targetDrawer.classList.add('active');
          if (!targetDrawer.classList.contains('mobile-menu-takeover')) {
            overlay.classList.add('active');
          }
          document.body.style.overflow = 'hidden';
        }
      });
    });

    closeBtns.forEach((btn) => {
      btn.addEventListener('click', closeAllDrawers);
    });

    if (overlay) {
      overlay.addEventListener('click', closeAllDrawers);
    }

    // --- MOBILE CART ICON -> OPEN NATIVE DAWN CART DRAWER ---



    // --- OPEN NATIVE DAWN CART DRAWER (shared helper, robust against reload race-condition) ---
    function openNativeCartDrawer(triggerEl) {
      const nativeCartDrawer = document.querySelector('cart-drawer');
      if (nativeCartDrawer && typeof nativeCartDrawer.open === 'function') {
        nativeCartDrawer.open(triggerEl);
        return true;
      }
      return false;
    }

    function bindCartIconToDrawer(icon) {
      if (!icon) return;
      icon.addEventListener('click', function (e) {
        e.preventDefault(); // sabse pehle rok do, taaki kabhi bhi /cart pe fallback na ho

        // Case 1: cart-drawer already upgrade ho chuka hai -> turant open
        if (openNativeCartDrawer(icon)) return;

        // Case 2: page abhi reload hua hai aur cart-drawer custom element
        // upgrade hone wala hai (yeh exactly product page wala race-condition hai)
        if (window.customElements && customElements.get('cart-drawer')) {
          customElements.whenDefined('cart-drawer').then(function () {
            openNativeCartDrawer(icon);
          });
        } else {
          // Case 3: is page pe cart-drawer element hai hi nahi -> normal /cart le jao
          window.location.href = icon.getAttribute('href');
        }
      });
    }


// --- DESKTOP CART ICON -> OPEN NATIVE DAWN CART DRAWER ---
    bindCartIconToDrawer(document.getElementById('cart-icon-bubble'));

    // --- MOBILE CART ICON -> OPEN NATIVE DAWN CART DRAWER ---
    const mobileCartIcon = document.getElementById('cart-icon-bubble-mobile');
    if (mobileCartIcon) {
      mobileCartIcon.addEventListener('click', function (e) {
        e.preventDefault();
        if (mobileMenu) mobileMenu.classList.remove('active');
        document.body.style.overflow = '';
        if (!openNativeCartDrawer(mobileCartIcon)) {
          window.location.href = mobileCartIcon.getAttribute('href');
        }
      });
    }

    // --- DESKTOP MEGA MENU: CLICK TO OPEN (NOT HOVER) ---
    const desktopDropdownTriggers = document.querySelectorAll('.has-dropdown > .dropdown-trigger');

    desktopDropdownTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const parentLi = trigger.closest('.has-dropdown');
        const isActive = parentLi.classList.contains('active');

        // Close any other open mega menu before opening this one
        document.querySelectorAll('.has-dropdown.active').forEach((li) => {
          if (li !== parentLi) li.classList.remove('active');
        });

        parentLi.classList.toggle('active', !isActive);
      });
    });

// Close mega menu on mouse leave (hover-out)
    const hasDropdownItems = document.querySelectorAll('.has-dropdown');

    hasDropdownItems.forEach((item) => {
      let leaveTimer;

      item.addEventListener('mouseleave', () => {
        leaveTimer = setTimeout(() => {
          item.classList.remove('active');
        }, 200); // thoda delay taaki gap/bridge cross karte waqt flicker na ho
      });

      item.addEventListener('mouseenter', () => {
        clearTimeout(leaveTimer);
      });
    });




    // --- CART: Pressing "-" at quantity 1 removes the item instead of showing "minimum" warning ---
    document.addEventListener('click', (e) => {
      const minusBtn = e.target.closest('.quantity__button[name="minus"]');
      if (!minusBtn) return;

      const cartItem = minusBtn.closest('.cart-item');
      if (!cartItem) return;

      const qtyInput = cartItem.querySelector('.quantity__input');
      if (qtyInput && parseInt(qtyInput.value, 10) <= 1) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const removeBtn = cartItem.querySelector('cart-remove-button button');
        if (removeBtn) removeBtn.click();
      }
    }, true);



    // Close mega menu on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        document.querySelectorAll('.has-dropdown.active').forEach((li) => li.classList.remove('active'));
      }
    });

    // --- MOBILE MENU MULTI-LEVEL DROPDOWN LOGIC ---
    const mobileDropdownToggles = document.querySelectorAll('.mobile-dropdown-toggle');

    mobileDropdownToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        toggle.classList.toggle('active');

        // Target specifically the direct nested <ul> without opening siblings
        const parentLi = toggle.closest('li');
        const dropdownMenu = parentLi.querySelector(':scope > .mobile-dropdown-menu');

        if (dropdownMenu) {
          dropdownMenu.classList.toggle('active');
        }
      });
    });
  });